import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DevicesFoldIcon(props: IconProps) {
    return <Icon {...props} iconKey={"devices_fold"}/>
}
